<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">500</h1>
            <h4 class="pt-3">Oops! Un Authorize Access.</h4>
            <p class="text-muted">The page you are looking for is secured.</p>
            <b-button
              v-if="$store.state.prevRoute && $store.state.prevRoute.name"
              variant="primary"
              class="px-4 mt-2"
              @click="goBack"
            >
              <i class="fa fa-arrow-left mr-2"></i> BACK
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnAuthorize",
  methods: {
    goBack() {
      const prev = this.$store.state.prevRoute;
      if (prev && prev.name) {
        this.$router.push({
          name: prev.name,
          params: prev.params || {},
          query: prev.query || {}
        });
      } else {
        this.$router.push({ name: 'app.home' });
      }
    }
  }
};
</script>

